module.exports = __webpack_public_path__ + "static/media/bell-b.b9a6d917.svg";